import { RefObject, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { loginUrl } from "../config/config"; // adjust import path as needed
import { handleLogout } from "../common/Function"; // adjust import path as needed

export const successToaster = (message: string, id: string | number | null = null): void => {
	toast.success(message, {
		position: "top-right",
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		icon: false,
		style: { color: "#fff" },
		...(id != null && { toastId: id })
	} as any);
};

export const errorToaster = (error: string, id: string | number | null = null): void => {
	toast.error(error, {
		position: "top-right",
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		icon: false,
		style: { color: "#fff" },
		...(id != null && { toastId: id })
	} as any);
};

// Replace this with your actual AuthContext type if available
interface AuthContextType {
	[key: string]: any;
}

export const handleOnLogin = (
	e: React.MouseEvent<HTMLElement>,
	authContext: AuthContextType | null
): void => {
	try {
		// Remove any existing CognitoIdentityServiceProvider cookies
		document.cookie.split(";").forEach(cookie => {
			if (cookie.trim().startsWith("CognitoIdentityServiceProvider")) {
				document.cookie = cookie
					.replace(/=.*/, "=;expires=" + new Date(0).toUTCString())
					.concat(";path=/;domain=konfhub.com");
			}
		});

		// Remove a generic authToken cookie
		Cookies.remove("authToken");

		// Remove any other “CognitoIdentityServiceProvider” cookies by key
		const allCookies = Cookies.get();
		Object.keys(allCookies).forEach(key => {
			if (key.includes("CognitoIdentityServiceProvider")) {
				Cookies.remove(key);
			}
		});

		// Call your existing logout handler (clears any local state, etc.)
		handleLogout(e, authContext);

		// Redirect user to the login page with a redirect parameter
		window.location.href = `${loginUrl}/login?redirect=Konfhub`;
	} catch (error) {
		console.error(error);
	}
};

export function useClickOutside<T extends HTMLElement>(
	ref: RefObject<T>,
	onClickOutside: () => void
): void {
	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				onClickOutside();
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, onClickOutside]);
}
